import type { CallOffAllocationShortfall } from '../../../lib/api';
import { toast } from 'sonner';

/**
 * Warn that a confirmed call-off's delivery lines cover less than was asked for.
 *
 * Shown wherever a confirmed call-off is (re)allocated — confirming it, adding a
 * part, raising a quantity — so a PO that no longer covers the quantity is never
 * saved short behind a plain success message: the supplier would ship short and
 * nobody would know why. A shortfall on ANOTHER call-off (one this change pushed
 * off the oldest PO line) is named by its reference.
 *
 * @param shortfalls - The parts the PO could not fully cover; nothing is shown when empty.
 */
export function warnAllocationShortfalls(shortfalls: CallOffAllocationShortfall[] | undefined): void {
  if (!shortfalls || shortfalls.length === 0) return;
  toast.warning(
    `PO coverage fell short — delivery lines cover the available quantity only: ` +
      shortfalls
        .map((s) => `${s.reference ? `${s.reference}: ` : ''}${s.part_number} short ${Number(s.shortfall)}`)
        .join(', '),
    { duration: 10000 },
  );
}
